import React from 'react'
import { NavLink } from 'redux-first-router-link'
import cx from 'classnames'
import { t } from 'ttag'

import { FadeScale } from 'components/shared/Transitions/FadeScale/FadeScale'

import EBHRIcon from 'images/ebhr-logo-white.svg'

import styles from './Logo.module.scss'

type SubLogoProps = {
  className?: string
  isInitialised?: boolean
}

const IconLogo = ({ className, isInitialised }: SubLogoProps) => {
  const ref = React.useRef<HTMLImageElement>(null)

  return (
    <FadeScale
      className={cx(styles.icon, className)}
      {...{ ref, isInitialised }}
    >
      <img alt="EBHR" ref={ref} src={EBHRIcon} />
    </FadeScale>
  )
}

const TextLogo = ({ className, isInitialised }: SubLogoProps) => {
  const ref = React.useRef<HTMLSpanElement>(null)

  return (
    <FadeScale
      className={cx(styles.text, className)}
      {...{ ref, isInitialised }}
    >
      <span ref={ref}>
        <span className={styles.prefix}>EBBER</span>
        <span className={styles.suffix}>{t`selection`}</span>
      </span>
    </FadeScale>
  )
}

type LogoProps = {
  className?: string
  redirectTo: React.ComponentProps<typeof NavLink>['to']
  isCollapsed?: boolean
  isTransparent?: boolean
}

export const Logo = ({
  className,
  redirectTo,
  isCollapsed,
  isTransparent,
}: LogoProps) => (
  <NavLink
    className={cx(
      styles.logo,
      {
        [styles.collapsed]: isCollapsed,
        [styles.transparent]: isTransparent,
      },
      className,
    )}
    to={redirectTo}
  >
    <IconLogo isInitialised={isCollapsed} />
    <TextLogo isInitialised={!isCollapsed} />
  </NavLink>
)
